var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckmarkCircleOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.25,
    height: 29.25,
    viewBox: "0 0 29.25 29.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon ionic-ios-checkmark-circle-outline"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1131",
    d: "m25.5 13.563-1.237-1.273a.266.266 0 0 0-.2-.084.255.255 0 0 0-.2.084l-8.578 8.641-3.121-3.121a.272.272 0 0 0-.394 0l-1.252 1.252a.28.28 0 0 0 0 .4l3.938 3.938a1.245 1.245 0 0 0 .823.4 1.3 1.3 0 0 0 .816-.387h.005l9.4-9.45a.3.3 0 0 0 0-.4z",
    style: {
      fill: "#00a727"
    },
    transform: "translate(-3.375 -3.375)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1132",
    d: "M18 5.344a12.651 12.651 0 1 1-8.951 3.705A12.573 12.573 0 0 1 18 5.344m0-1.969A14.625 14.625 0 1 0 32.625 18 14.623 14.623 0 0 0 18 3.375z",
    style: {
      fill: "#00a727"
    },
    transform: "translate(-3.375 -3.375)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkCircleOutline);
export default __webpack_public_path__ + "static/media/checkmark-circle-outline.912d8ba9d1752abe352719c43337ec42.svg";
export { ForwardRef as ReactComponent };